module.exports = __webpack_public_path__ + "img/title_3.cde43f69.png";